import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["line", "cursor"]

  connect() {
    this.played = false
    this.lineTargets.forEach(line => line.style.opacity = "0")
    if (this.hasCursorTarget) this.cursorTarget.style.opacity = "0"

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !this.played) {
        this.played = true
        this.playAnimation()
        this.observer.disconnect()
      }
    }, { threshold: 0.4 })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  playAnimation() {
    this.lineTargets.forEach((line, i) => {
      setTimeout(() => {
        line.style.opacity = "1"
        if (i === this.lineTargets.length - 1 && this.hasCursorTarget) {
          setTimeout(() => { this.cursorTarget.style.opacity = "1" }, 200)
        }
      }, i * 400)
    })
  }
}
